export const PRICE_GUIDE = {
  PRODUCT_MODEL: 'price_guide_product_model',
}
